<template>
  <!-- 国际化-语言切换组件 -->
  <section class="lang-switch">
    <el-select v-model="lang" :placeholder="$t('请选择')" class="lang-switch-select" @change="onLangChange">
      <!-- 中文 -->
      <el-option label="中文" value="zh-cn">
        <div class="lang-switch-list">
          <span>中文</span>
          <span class="lang-switch-icon">
            <img src="@/assets/icon/china-icon.png" alt="中文">
          </span>
        </div>
      </el-option>
      <!-- 英文 -->
      <el-option label="English" value="en">
        <div class="lang-switch-list">
          <span>English</span>
          <span class="lang-switch-icon">
            <img src="@/assets/icon/usa-icon.png" alt="English">
          </span>
        </div>
      </el-option>
      <!-- 俄文 -->
      <el-option label="Русский язык" value="ru">
        <div class="lang-switch-list">
          <span>Русский язык</span>
          <span class="lang-switch-icon">
            <img src="@/assets/icon/russia-icon.png" alt="Русский язык">
          </span>
        </div>
      </el-option>
    </el-select>

    <!-- 选中后的数据Icon -->
    <img v-if="lang === 'zh-cn'" src="@/assets/icon/china-icon.png" alt="中文" class="lang-switch-check-icon">
    <img v-else-if="lang === 'en'" src="@/assets/icon/usa-icon.png" alt="English" class="lang-switch-check-icon">
    <img v-else-if="lang === 'ru'" src="@/assets/icon/russia-icon.png" alt="Русский язык" class="lang-switch-check-icon">
  </section>
</template>

<script>
import request from "../../utils/request";

export default {
  name: "LangSwitch",
  props: {
    value: { type: String },
  },
  data() {
    return {
      //读取当前缓存的数据，默认中文
      lang: this.value || localStorage.getItem('_SystemLanguage') || 'zh-cn'
    }
  },
  //创建时进行初始化
  created() {
    //检查当前是否存在国际化缓存
    /*let LangCache = localStorage.getItem('_LanguageCache');
    if(LangCache) {
      LangCache = JSON.parse(LangCache);
      //验证当前缓存有效性（验证时间和版本）
      LangCache.cache && LangCache.expire > Date.now() && LangCache.version === LangVersion ?
        //依据缓存设置语言包
        this.initSetLangPack(LangCache.data) :
          //重新读取后端语言包
          this.initLoadLangPack();
    }
    else {
      //动态读取后端语言包
      this.initLoadLangPack();
    }*/
  },
  watch: {

  },
  methods: {
    onLangChange(val) {
      //加载动画（虚拟切换加载）
      const loading = this.$loading({
        lock: true, text: 'Loading...',//'语言切换中，请稍候',
        spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)'
      });

      setTimeout(()=> {

        //写入当前缓存中
        localStorage.setItem('_SystemLanguage', val);
        
        //如果切换到非中文语言，清除"跳过"标记
        if(val !== 'zh-cn') {
          localStorage.removeItem('_SkipLanguageCache');
        }

        //window.location.reload();   //刷新页面，应用新的语言
        this.$i18n.locale = val;      //进行语言切换

        loading.close();    //完成切换后关闭加载效果

      }, 300);

    },
    //初始化加载语言包
    /*initLoadLangPack() {
      //动态读取后端的翻译数据
      request({
        url: '/languageTranslations/listAllLanguageTranslations',
        method: 'get',
      }).then(data => {
        //转换国际化的数据
        if(data.code === 200) {
          data = data.data;
          //写入当前国际化校验数据
          localStorage.setItem('_LanguageCache', JSON.stringify({
            cache: true, expire: Date.now() + 60000 * 60 * 24,  //缓存时间一天
            data: data
          }));

          //以当前数据设置语言包
          this.initSetLangPack(data);
        }
      });
    },
    //初始化设置语言包
    initSetLangPack(data) {
      //整合英文与俄文数据
      let enData = {}, ruData = {};
      data.forEach(d => {
        d.english && (enData[d.chinese] = d.english);
        d.russian && (ruData[d.chinese] = d.russian);
      });

      //移除当前语言包
      //this.$i18n.setLocaleMessage('en', {});
      //this.$i18n.setLocaleMessage('ru', {});
      //初始化写入语言包数据（按需写入）
      //this.$i18n.locale === 'en' && this.$i18n.setLocaleMessage('en', enData);
      //this.$i18n.locale === 'ru' && this.$i18n.setLocaleMessage('ru', ruData);

      //按需加载时切换语言需重载语言包，翻译无性能瓶颈时仅加载一次语言包即可
      this.$i18n.setLocaleMessage('en', enData);
      this.$i18n.setLocaleMessage('ru', ruData);
    }*/
  }
}
</script>

<style scoped lang="scss">
.lang-switch {
  position: relative;
  height: 40px;
  width: 185px;
}
.lang-switch-select {
  display: inherit;
}
.lang-switch-list {
  display: flex;
  justify-content: space-between;
}
.lang-switch-icon img {
  width: 33px;
  height: 22px;
  margin-top: 6px;
  border: 1px solid #EEE;
}
//选中后的数据Icon
.lang-switch-check-icon {
  width: 33px;
  height: 22px;
  position: absolute;
  right: 35px;
  top: 8px;
  border: 1px solid #EEE;
}
</style>



// WEBPACK FOOTER //
// src/components/LangSwitch/index.vue